import classNames from 'classnames';
import { FlexContainer, Txt, View } from 'components';
import { formatCurrency } from 'helpers/formatNumber';
import styles from './ViewPaymentsHeader.module.scss';

/**
 * ViewPaymentsHeader
 *
 * @return {JSX.Element}
 */
const ViewPaymentsHeader = ({
  className,
  label,
  currentValue,
  expectedValue,
}) => {
  return (
    <FlexContainer
      className={classNames(
        styles.ViewPaymentsHeader,
        className,
        ViewPaymentsHeader.displayName
      )}
      column
      gapHalf
    >
      <Txt caption>{label}</Txt>
      <View>
        <Txt xxx bold>
          £{formatCurrency(currentValue || 0)}
        </Txt>
        <Txt caption>/£{formatCurrency(expectedValue || 0)}</Txt>
      </View>
    </FlexContainer>
  );
};

ViewPaymentsHeader.displayName = 'ViewPaymentsHeader';

export default ViewPaymentsHeader;
